import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';
import { CONTACT_INFO } from '../data/showData';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#0a0a0a]">
      <div className="container-custom max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-gray-400 hover:text-[#FFD700] transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla home
        </Link>

        <div className="bg-[#121212] rounded-2xl border border-white/5 p-6 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Cookie className="w-8 h-8 text-[#D946EF]" />
            <h1 className="text-3xl md:text-4xl font-bold text-white">Cookie Policy</h1>
          </div>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <p className="text-gray-400 text-sm">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">Cosa sono i cookie?</h2>
              <p>
                I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo 
                quando visiti un sito web. Servono a migliorare la tua esperienza di navigazione 
                e a fornire informazioni ai proprietari del sito.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">Cookie che utilizziamo</h2>
              
              <h3 className="text-lg font-medium text-[#FFD700] mt-6 mb-3">Cookie tecnici (necessari)</h3>
              <p>
                Questi cookie sono essenziali per il funzionamento del sito e non possono essere 
                disattivati. Includono cookie per la gestione della sessione e delle preferenze 
                di navigazione.
              </p>

              <h3 className="text-lg font-medium text-[#FFD700] mt-6 mb-3">Cookie analitici</h3>
              <p>
                Utilizziamo cookie analitici per comprendere come i visitatori interagiscono con 
                il nostro sito. Questi dati ci aiutano a migliorare il sito e l'esperienza utente. 
                I dati sono raccolti in forma anonima.
              </p>

              <h3 className="text-lg font-medium text-[#FFD700] mt-6 mb-3">Cookie di terze parti</h3>
              <p>
                Il nostro sito può includere contenuti di terze parti (es. video embedded, mappe) 
                che potrebbero impostare i propri cookie. Non abbiamo controllo su questi cookie.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">Come gestire i cookie</h2>
              <p>
                Puoi controllare e/o eliminare i cookie come desideri. Puoi eliminare tutti i 
                cookie già presenti sul tuo computer e puoi impostare la maggior parte dei browser 
                in modo da bloccarne l'installazione.
              </p>
              <p className="mt-4">
                Per gestire i cookie nel tuo browser:
              </p>
              <ul className="list-disc list-inside space-y-2 mt-4">
                <li>Chrome: Impostazioni → Privacy e sicurezza → Cookie</li>
                <li>Firefox: Opzioni → Privacy e sicurezza → Cookie</li>
                <li>Safari: Preferenze → Privacy → Cookie</li>
                <li>Edge: Impostazioni → Privacy e sicurezza → Cookie</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">Durata dei cookie</h2>
              <p>
                I cookie di sessione vengono eliminati quando chiudi il browser. I cookie 
                persistenti rimangono sul tuo dispositivo per un periodo definito o fino a 
                quando non li elimini manualmente.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">Aggiornamenti</h2>
              <p>
                Questa Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a 
                consultarla regolarmente per essere informato su come proteggiamo le tue 
                informazioni.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">Contatti</h2>
              <p>
                Per domande sulla nostra Cookie Policy, contattaci:
              </p>
              <ul className="list-none space-y-2 mt-4">
                <li>Email: {CONTACT_INFO.email}</li>
                <li>WhatsApp: {CONTACT_INFO.whatsappDisplay}</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
